const dateSelection = {
  calRef: undefined,

  selectSingleDate(e: {
    target: {
      classList: { contains: (arg0: string) => any };
      parentNode: {
        classList: { contains: (arg0: string) => any };
        title: string;
        style: { background: string; backgroundColor: string };
        setAttribute: (arg0: string, arg1: string) => void;
      };
      title: string;
      style: { background: string; backgroundColor: string; color: string };
      firstChild: { style: { color: string }; innerText: any };
      setAttribute: (arg0: string, arg1: string) => void;
      innerText: any;
    };
  }): void {
    this.clearPreviouslySelectedDates(true);
    const isCalDay = e.target.classList.contains('day');
    const isDaySpan = e.target.parentNode.classList.contains('day');
    const dayWithVariousEvents =
      this.calRef.isDayWithVariousEvents(`${e.target.title.split(':')[0]}:`) ||
      this.calRef.isDayWithVariousEvents(`${e.target.parentNode.title.split(':')[0]}:`);

    dayWithVariousEvents
      ? (e.target.style.background = e.target.parentNode.style.background = 'none')
      : null;

    if (isCalDay) {
      e.target.style.backgroundColor = '#2bc358';
      e.target.firstChild.style.color = '#fff';
      this.calRef.selectedSingleDate = this.calRef.getDateWithRequiredFormat(
        this.calRef.getPickedDate(e.target.firstChild.innerText),
      );
      e.target.setAttribute('data-selected-single-date', 'true');
    } else if (isDaySpan) {
      e.target.parentNode.style.backgroundColor = '#2bc358';
      e.target.style.color = '#fff';
      this.calRef.selectedSingleDate = this.calRef.getDateWithRequiredFormat(
        this.calRef.getPickedDate(e.target.innerText),
      );
      e.target.parentNode.setAttribute('data-selected-single-date', 'true');
    }
  },

  selectMultipleDates(e: Record<string, any>): void {
    // Because this keyword refers to event target
    const calRef = dateSelection.calRef;

    const isCalDay = e.target.classList.contains('day');
    const isDaySpan = e.target.parentNode.classList.contains('day');
    const dayToPass = isCalDay ? e.target.firstChild.innerText : e.target.innerText;
    const monthAndYear = (document.querySelector('#sweetCalendar .month') as HTMLElement).innerText;
    const selectedDate = calRef.getDateWithRequiredFormat(`${dayToPass} ${monthAndYear}`);
    const dateAlreadySelected = calRef.selectedDates.includes(selectedDate);
    const dayWithVariousEvents =
      calRef.isDayWithVariousEvents(`${e.target.title.split(':')[0]}:`) ||
      calRef.isDayWithVariousEvents(`${e.target.parentNode.title.split(':')[0]}:`);

    if (dayWithVariousEvents) {
      isCalDay ? (e.target.style.background = 'none') : null;
      isDaySpan ? (e.target.parentNode.style.background = 'none') : null;
    }

    // Click on the div tag
    if (isCalDay && !dateAlreadySelected) {
      setTimeout(() => {
        e.target.style.backgroundColor = '#2bc358';
      });

      e.target.firstChild.style.color = '#fff';
      calRef.selectedDates.push(
        calRef.getDateWithRequiredFormat(calRef.getPickedDate(e.target.firstChild.innerText)),
      );

      if (e.target.hasAttribute('data-is-busy')) calRef.selectedBusyDates.push(selectedDate);
    } else if (isCalDay && dateAlreadySelected) {
      dateSelection.determineWhichColorsShouldBeAppliedIfDateIsUnselected(e, 'calDay');

      calRef.selectedDates.splice(
        calRef.selectedDates.indexOf(
          calRef.getDateWithRequiredFormat(calRef.getPickedDate(e.target.firstChild.innerText)),
        ),
        1,
      );

      if (e.target.hasAttribute('data-is-busy')) {
        calRef.selectedBusyDates.splice(calRef.selectedBusyDates.indexOf(selectedDate), 1);
      }
    }

    // Click on the span tag
    if (isDaySpan && !dateAlreadySelected) {
      setTimeout(() => {
        e.target.parentNode.style.backgroundColor = '#2bc358';
      });

      e.target.style.color = '#fff';
      calRef.selectedDates.push(
        calRef.getDateWithRequiredFormat(calRef.getPickedDate(e.target.innerText)),
      );

      if (e.target.parentNode.hasAttribute('data-is-busy'))
        calRef.selectedBusyDates.push(selectedDate);
    } else if (isDaySpan && dateAlreadySelected) {
      dateSelection.determineWhichColorsShouldBeAppliedIfDateIsUnselected(e, 'daySpan');

      calRef.selectedDates.splice(
        calRef.selectedDates.indexOf(
          calRef.getDateWithRequiredFormat(calRef.getPickedDate(e.target.innerText)),
        ),
        1,
      );

      if (e.target.parentNode.hasAttribute('data-is-busy')) {
        calRef.selectedBusyDates.splice(calRef.selectedBusyDates.indexOf(selectedDate), 1);
      }
    }
  },

  clearPreviouslySelectedDates(selectingNewSingleDate?: boolean): void {
    const allDaysEls = document.querySelectorAll('#sweetCalendar .day');

    allDaysEls.forEach((day: any) => {
      if (selectingNewSingleDate && day.hasAttribute('data-selected-single-date')) {
        day.removeAttribute('data-selected-single-date');
      }

      if (day.style.backgroundColor === 'rgb(43, 195, 88)') {
        this.handleUnselectingLogic(day, day.firstChild);
      }
    });
  },

  determineWhichColorsShouldBeAppliedIfDateIsUnselected(
    e: { target?: { parentNode: any; firstChild: any } },
    clickedElement: string,
  ): void {
    const divTag = clickedElement === 'calDay' ? e.target : e.target.parentNode;
    const spanTag = clickedElement === 'calDay' ? e.target.firstChild : e.target;

    this.handleUnselectingLogic(divTag, spanTag);
  },

  handleUnselectingLogic(
    parentTag: {
      getAttribute: (arg0: string) => string;
      style: { backgroundColor: string; background: any };
    },
    childTag: { style: { color: string; fontWeight: any } },
  ): void {
    if (parentTag.getAttribute('title') === null) {
      parentTag.style.backgroundColor = '#f3fff8';
      childTag.style.color = '#707070';
      return;
    }

    Object.values(this.eventTypes).forEach((eventType: any, i, arr) => {
      if (`${parentTag.getAttribute('title').split(':')[0]}:` === this.calRef.$t(eventType.copy)) {
        parentTag.style.backgroundColor = eventType.parentStyle.backgroundColor;
        parentTag.style.background = eventType.parentStyle.background;
        childTag.style.fontWeight = eventType.childStyle.fontWeight;
        childTag.style.color = eventType.childStyle.color;
      } else if (arr.length - 1 === i && !parentTag.style.backgroundColor) {
        parentTag.style.backgroundColor = '#f3fff8';
        childTag.style.color = '#707070';
      }
    });
  },

  applySelectedDates(self: unknown): void {
    if (!this.calRef) this.calRef = self;
    if (!this.calRef.calendarExists) return;

    const allDaysElements = document.querySelectorAll('#sweetCalendar .day');
    const monthAndYear = (document.querySelector('#sweetCalendar .month') as HTMLElement).innerText;

    allDaysElements.forEach((day: any) => {
      const dateCurrentMonthAndYear = this.calRef.getDateWithRequiredFormat(
        `${day.firstChild.innerText} ${monthAndYear}`,
      );
      const canShowSelectedSingleDate =
        this.calRef.selectedSingleDate === dateCurrentMonthAndYear && this.calRef.pickSingleDate;

      if (
        this.calRef.selectedDates.includes(dateCurrentMonthAndYear) ||
        canShowSelectedSingleDate
      ) {
        (day.style = 'background-color: #2bc358;'), (day.firstChild.style.color = '#fff');
      }
    });
  },

  eventTypes: {
    assessments: {
      copy: 'numOfAssessmentsThisDay1',
      parentStyle: {
        backgroundColor: '#2b89c3',
      },
      childStyle: {
        color: '#fff',
      },
    },

    proposedAssessments: {
      copy: 'numOfAssessmentsThisDay2',
      parentStyle: {
        backgroundColor: '#41bbdc',
      },
      childStyle: {
        color: '#fff',
      },
    },

    assessmentsAndProposedAssessments: {
      copy: 'numOfAssessmentsThisDay3',
      parentStyle: {
        background: '-webkit-linear-gradient(0deg, #41bbdc 50%, #2b89c3 50%)',
      },
      childStyle: {
        color: '#fff',
        fontWeight: 'bold',
      },
    },

    deadlines: {
      copy: 'deadlinesThisDay',
      parentStyle: {
        backgroundColor: '#707070',
      },
      childStyle: {
        color: '#fff',
      },
    },

    deadlinesAndAssessments: {
      copy: 'eventsThisDay1',
      parentStyle: {
        background: '-webkit-linear-gradient(0deg, #707070 50%, #2b89c3 50%)',
      },
      childStyle: {
        color: '#fff',
        fontWeight: 'bold',
      },
    },

    deadlinesAndProposedAssessments: {
      copy: 'eventsThisDay2',
      parentStyle: {
        background: '-webkit-linear-gradient(0deg, #707070 50%, #41bbdc 50%)',
      },
      childStyle: {
        color: '#fff',
        fontWeight: 'bold',
      },
    },
  },
};

export default dateSelection;
